<template>
<div class="search-member">
        <transition :name="transition">
            <div v-show="show" class="member-container">
                <div class="loading" v-show="loading">
                    <img src="@/assets/h5/loading2.gif">
                </div>
                <div v-show="data.length > 0" class="member-content data">
                    <div class="member-list" v-for="(item, index) in data" :key="index" @click="selectMember(item)">
                        <Member :data="item"></Member>
                    </div>
                </div>
                <div v-show="data.length <= 0 && !loading" class="member-content no-data">
                    <svg-icon icon-class="file-transfer-search-no-data" class="no-data-icon"></svg-icon>
                    <span class="no-data-tip">{{$t("未搜索到相关内容#!!!#src/pages/H5/Cloud/components/transfer/searchMember.vue_1")}}</span>
                    <span class="no-data-tip-last">{{$t("请检查后重新搜索#!!!#src/pages/H5/Cloud/components/transfer/searchMember.vue_1")}}</span>
                </div>
            </div>
        </transition>
        <slot name="reference"></slot>
    </div>
</template>

<script>
import Member from "./member.vue";
import { searchMember } from "@/api/h5/file";
import { getMemberAvatar } from "@/utils/avatar";

export default {
    name: "SearchMember",
    components: {
        Member
    },
    props: {
        transition: {
            type: String,
            default: 'fade-in-linear'
        },
        reference: {},
        searchText: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            show: false,
            loading: false,
            data: [],
        }
    },
    watch: {
        searchText: {
            handler(val) {
                if (val) {
                    this.show = this.loading = true;
                    this.querySearchMember();
                } else {
                    this.show = this.loading = false;
                }
            },
            immediate: true
        }
    },
    methods: {
        querySearchMember() {
            this.data = []
            searchMember(this.searchText, false).then((res) => {
                if (res.data.searchKey !== this.searchText) {
                    this.loading = false;
                    return;
                }
                if (!res.success) {
                    this.loading = false;
                    return;
                }
                const { members = [] } = res.data;
                this.handlerContacts(members);
                this.loading = false;
            }).catch(err => {
                this.loading = false;
            });
        },
        handlerContacts(memberList) {
            const result = []
            memberList.map(user => {
                const { departments = [] } = user
                let department_name = ''
                if (departments) {
                    for (var i = 0; i < departments.length; i++) {
                        let depart = departments[i]
                        department_name += depart.departmentName
                        if (i < (departments.length - 1)) {
                            department_name += '/'
                        }
                    }
                }
                result.push({
                    memberName: user.memberName,
                    userId: user.userId,
                    spaceId: user.spaceId,
                    memberAvatar: getMemberAvatar(user.memberAvatar)['100'],
                    departmentName: department_name,
                    id: user.id,
                })
            })
            this.data = this.data.concat(result)
        },
        selectMember(item) {
            this.show = false;
            this.$emit('selectMember', item);
        }
    },
    created() {
    },
}
</script>

<style lang="scss" scoped>
.search-member {
    position: relative;
    width: 100%;
    height: 32px;
    display: inline-flex;
    flex: 1;

    .member-container {
        width: 495px;
        height: 300px;
        background: #FFFFFF;
        border: 1px solid #E6E8EC;
        box-shadow: 0 8px 12px 0 #1213171a;
        border-radius: 8px;
        position: absolute;
        top: 40px;
        left: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2000;

        .loading {
            img {
                width: 24px;
                height: 24px;
            }
        }

        .member-content {
            width: calc(100% - 8px);
            margin: 0 4px;
            height: 100%;

            &.data {
                overflow-x: hidden;
                overflow-y: auto;

                .member-list {
                    margin: 4px 4px 0px 4px;
                    height: 45px;
                    cursor: pointer;

                    &:hover {
                        background: #F4F6F9;
                        border-radius: 8px;
                    }
                }

                &::-webkit-scrollbar {
                    width: 4px;
                    border-radius: 3px;
                }

                &::-webkit-scrollbar-thumb {
                    cursor: pointer;
                    background: #DCDDDE;
                    border-radius: 3px;
                    transition: 0.3s background-color;
                }

                &::-webkit-scrollbar-track {
                    opacity: 0;
                    transition: opacity 120ms ease-out;
                }
            }

            &.no-data {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .no-data-icon {
                    width: 175px;
                    height: 116px;
                    margin-bottom: 12px;
                }

                .no-data-tip {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #646573;
                    line-height: 20px;
                    margin-bottom: 4px;
                }

                .no-data-tip-last {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 12px;
                    color: #A2A4B0;
                }
            }
        }
    }

}
</style>
